module.exports = __webpack_public_path__ + "static/media/LoaderAnimation.2bdefe97.svg";